/* eslint-disable radix */
class InputQuantityElement extends HTMLElement {
  constructor() {
    super();
    this.minus = null;
    this.plus = null;
    this.input = null;
    this.min = undefined;
    this.max = undefined;
    this.qte = 1;
    this.previousValidValue = this.qte;
  }

  connectedCallback() {
    this.initQuantityInput();
  }

  disconnectedCallback() {
    // Clean up event listeners when the element is removed from the DOM
    if (this.minus) {
      this.minus.removeEventListener("click", this.decrementQuantity);
    }
    if (this.plus) {
      this.plus.removeEventListener("click", this.incrementQuantity);
    }
    if (this.input) {
      this.input.removeEventListener("change", this.handleInputChange);
    }
  }

  initQuantityInput() {
    // Query the elements (input, minus, plus) inside the custom element
    this.minus = this.querySelector(".input-quantity__minus");
    this.plus = this.querySelector(".input-quantity__plus");
    this.input = this.querySelector(".input-quantity__input");

    // We assume the min, max, and value attributes are already set via the parent component.
    this.min = this.input.min ? parseInt(this.input.min) : undefined;
    this.max = this.input.max ? parseInt(this.input.max) : undefined;
    this.qte = parseInt(this.input.value) || 1; // Default to 1 if not set

    // Disable buttons when limits are reached
    const updateButtonStates = () => {
      if (this.min !== undefined) this.minus.disabled = this.qte <= this.min;
      if (this.max !== undefined) this.plus.disabled = this.qte >= this.max;
    };

    // Event listener for minus button
    this.decrementQuantity = () => {
      if (this.qte > (this.min || 0)) {
        this.qte -= 1;
        this.input.value = this.qte;
        updateButtonStates();
      }
    };
    this.minus.addEventListener("click", this.decrementQuantity);

    // Event listener for plus button
    this.incrementQuantity = () => {
      if (this.qte < (this.max || Infinity)) {
        this.qte += 1;
        this.input.value = this.qte;
        updateButtonStates();
      }
    };
    this.plus.addEventListener("click", this.incrementQuantity);

    this.handleInputChange = () => {
      let value = parseInt(this.input.value) || 0;

      // Ensure value is within min/max if they exist
      if (this.min !== undefined && value < this.min) value = this.min;
      if (this.max !== undefined && value > this.max) value = this.max;

      this.qte = value; // Update qte
      this.input.value = this.qte; // Set the validated value back into the input
      this.previousValidValue = this.qte; // Update the last valid value
      updateButtonStates();
    };
    this.input.addEventListener("change", this.handleInputChange);

    // Initial button state check
    updateButtonStates();
  }
}

// Define the custom element
customElements.define("input-quantity", InputQuantityElement);
